// Global Theme JavaScript
document.addEventListener('DOMContentLoaded', () => {
  // Sticky Header
  const header = document.querySelector('header-section');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 100) {
        header.classList.add('is-sticky');
      } else {
        header.classList.remove('is-sticky');
      }
      lastScroll = currentScroll;
    });
  }

  // Global Wishlist & AJAX Add to Cart Logic using event delegation
  let wishlist = [];
  try {
    wishlist = JSON.parse(localStorage.getItem('theme_wishlist') || '[]');
  } catch (e) {}

  const updateWishlistBubble = () => {
    let wishlistArr = [];
    try {
      wishlistArr = JSON.parse(localStorage.getItem('theme_wishlist') || '[]');
    } catch (e) {}
    const count = Array.isArray(wishlistArr) ? wishlistArr.length : 0;
    document.querySelectorAll('.wishlist-count-bubble').forEach(bubble => {
      bubble.textContent = count;
      if (count > 0) {
        bubble.style.display = 'flex';
      } else {
        bubble.style.display = 'none';
      }
    });
  };

  const updateWishlistButtons = () => {
    try {
      wishlist = JSON.parse(localStorage.getItem('theme_wishlist') || '[]');
    } catch (e) {}
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (wishlist.includes(handle)) {
        btn.classList.add('active');
        const svg = btn.querySelector('svg');
        if (svg) {
          svg.style.fill = '#e22c2c';
          svg.style.stroke = '#e22c2c';
        }
      } else {
        btn.classList.remove('active');
        const svg = btn.querySelector('svg');
        if (svg) {
          svg.style.fill = 'none';
          svg.style.stroke = 'currentColor';
        }
      }
    });
    updateWishlistBubble();
  };

  window.updateWishlistBubble = updateWishlistBubble;
  window.updateWishlistButtons = updateWishlistButtons;
  updateWishlistButtons();
  updateWishlistBubble();

  let cartItemsMap = {};
  window.getVariantQtyInCart = function(variantId) {
    if (!variantId) return 0;
    const strId = variantId.toString();
    return cartItemsMap[strId] || cartItemsMap[parseInt(strId)] || 0;
  };
  window.addBlinkitProductToCart = function(event, variantId) {
    if (event && event.preventDefault) event.preventDefault();
    const btn = (event && event.currentTarget) || document.querySelector(`.blinkit-add-btn[data-variant-id="${variantId}"]`);
    if (btn) {
      btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }
  };
  const variantDebounceTimers = {};
  const variantRequestSequence = {};

  let lastUniqueCartCount = 0;

  const getOptimisticTotalCartItems = () => {
    let sum = 0;
    Object.keys(cartItemsMap).forEach(k => {
      const q = parseInt(cartItemsMap[k]) || 0;
      if (q > 0) {
        sum += q;
      }
    });
    return sum;
  };
  window.getOptimisticTotalCartItems = getOptimisticTotalCartItems;

  const updateCartBubble = (count) => {
    const bubbles = document.querySelectorAll('.cart-count-bubble');
    const totalCount = (typeof count === 'number' && !isNaN(count)) ? count : lastUniqueCartCount;
    lastUniqueCartCount = totalCount;

    bubbles.forEach(bubble => {
      bubble.textContent = totalCount;
      if (totalCount > 0) {
        bubble.style.display = 'flex';
      } else {
        bubble.style.display = 'none';
      }
    });
  };

  const updateSearchCartPill = (cart) => {
    const countEl = document.getElementById('FullSearchCartCount');
    const totalEl = document.getElementById('FullSearchCartTotal');

    if (!cart) {
      fetch(window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js')
        .then(res => res.json())
        .then(data => updateSearchCartPill(data))
        .catch(() => {});
      return;
    }

    const uniqueVariantsCount = cart && cart.items ? cart.items.length : lastUniqueCartCount;
    const totalPriceCents = typeof cart.total_price === 'number' ? cart.total_price : 0;
    const rupees = Math.round(totalPriceCents / 100);

    if (countEl) countEl.textContent = `${uniqueVariantsCount} ${uniqueVariantsCount === 1 ? 'Item' : 'Items'}`;
    if (totalEl) totalEl.textContent = `₹${rupees.toLocaleString('en-IN')}`;

    updateCartBubble(uniqueVariantsCount);
  };
  window.updateSearchCartPill = updateSearchCartPill;

  const renderProductCardAtc = (container, variantId, qty, direction = null) => {
    if (!container) return;
    const isAvailable = container.dataset.available !== 'false';

    if (qty > 0) {
      const existingSelector = container.querySelector('.product-card__qty-selector');
      if (existingSelector) {
        const numEl = existingSelector.querySelector('.qty-num');
        if (numEl) {
          numEl.textContent = qty;
          if (direction) {
            numEl.classList.remove('qty-inc', 'qty-dec');
            void numEl.offsetWidth; // Trigger reflow to restart CSS animation
            numEl.classList.add(direction === 'inc' ? 'qty-inc' : 'qty-dec');
          }
          return;
        }
      }

      const animClass = direction === 'inc' ? 'qty-inc' : (direction === 'dec' ? 'qty-dec' : '');
      container.innerHTML = `
        <div class="product-card__qty-selector" data-variant-id="${variantId}">
          <button type="button" class="qty-btn qty-btn--minus" data-action="minus" aria-label="Decrease quantity">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          </button>
          <span class="qty-count">
            <span class="qty-num ${animClass}">${qty}</span>
          </span>
          <button type="button" class="qty-btn qty-btn--plus" data-action="plus" aria-label="Increase quantity">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
          </button>
        </div>
      `;
    } else {
      if (isAvailable) {
        container.innerHTML = `
          <button type="button" class="blinkit-add-btn" data-variant-id="${variantId}">
            ADD
          </button>
        `;
      } else {
        container.innerHTML = `
          <button type="button" class="blinkit-add-btn" data-variant-id="${variantId}" disabled style="opacity: 0.6; cursor: not-allowed;">
            Sold Out
          </button>
        `;
      }
    }
  };

  const updateCardContainersForVariant = (variantId, qty, direction = null, realVariantId = null) => {
    if (!variantId) return;
    const strId = variantId.toString();
    const strRealId = realVariantId ? realVariantId.toString() : strId;

    document.querySelectorAll(`.product-card__atc-container[data-variant-id="${strId}"], .product-card__atc-container[data-variant-id="${strRealId}"]`).forEach(container => {
      container.dataset.variantId = strRealId;
      renderProductCardAtc(container, strRealId, qty, direction);
    });
  };

  let serverCartMap = {};

  const syncVariantQuantityToServer = (variantId, targetQty) => {
    if (!variantId) return;
    const strId = variantId.toString();

    if (variantDebounceTimers[strId]) {
      clearTimeout(variantDebounceTimers[strId]);
    }

    const seq = (variantRequestSequence[strId] || 0) + 1;
    variantRequestSequence[strId] = seq;

    variantDebounceTimers[strId] = setTimeout(() => {
      delete variantDebounceTimers[strId];

      const currentServerQty = serverCartMap[strId] || 0;
      const isNewItem = currentServerQty === 0;

      let fetchPromise;
      if (isNewItem) {
        fetchPromise = fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: strId,
            quantity: targetQty
          })
        });
      } else {
        fetchPromise = fetch(window.routes?.cart_change_url || '/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: strId,
            quantity: targetQty
          })
        });
      }

      fetchPromise
        .then(res => {
          if (!res.ok) throw new Error('Network response failed');
          return res.json();
        })
        .then(data => {
          if (seq !== variantRequestSequence[strId]) return;
          syncCartWithServer();
        })
        .catch(err => {
          console.error('Error syncing variant quantity:', err);
          syncCartWithServer();
        });
    }, 220);
  };

  const checkProductPageAtcButtonState = () => {
    const addBtns = document.querySelectorAll('.custom-details__add-btn, .pdp-open-variants-btn');
    const stickyAtcBtn = document.getElementById('gnc-sticky-atc-btn');
    if (!addBtns.length && !stickyAtcBtn) return;

    let totalQty = 0;
    const variantsScript = document.querySelector('.product-variants-data-json, [id^="product-variants-json-"]');
    if (variantsScript) {
      try {
        const parsed = JSON.parse(variantsScript.textContent.trim());
        if (Array.isArray(parsed)) {
          totalQty = parsed.reduce((sum, v) => sum + (cartItemsMap[v.id.toString()] || 0), 0);
        }
      } catch (e) {}
    } else {
      const variantInput = document.getElementById('custom-details-selected-variant-id');
      const singleVId = (variantInput && variantInput.value) || (addBtns[0] && addBtns[0].getAttribute('data-variant-id'));
      if (singleVId) {
        totalQty = cartItemsMap[singleVId.toString()] || 0;
      }
    }

    if (totalQty > 0) {
      addBtns.forEach(btn => {
        btn.classList.add('is-add-more');
        btn.classList.remove('added', 'is-view-cart');
        btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg><span class="btn-text">Add More</span>';
      });
      if (stickyAtcBtn) {
        stickyAtcBtn.classList.add('is-add-more');
        stickyAtcBtn.classList.remove('is-view-cart');
        stickyAtcBtn.textContent = 'Add More';
      }
    } else {
      addBtns.forEach(btn => {
        btn.classList.remove('is-add-more', 'added', 'is-view-cart');
        btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg><span class="btn-text">Add to Cart</span>';
      });
      if (stickyAtcBtn) {
        stickyAtcBtn.classList.remove('is-add-more', 'is-view-cart');
        stickyAtcBtn.textContent = 'Add to Cart';
      }
    }
  };

  window.checkProductPageAtcButtonState = checkProductPageAtcButtonState;

  const syncCartWithServer = () => {
    const url = (window.routes?.cart_url ? `${window.routes.cart_url}.js` : '/cart.js') + '?_=' + Date.now();
    return fetch(url, { cache: 'no-store' })
      .then(res => res.json())
      .then(cart => {
        const newMap = {};
        const newServerMap = {};
        if (cart.items) {
          cart.items.forEach(item => {
            const vId = item.variant_id.toString();
            newServerMap[vId] = item.quantity;
            newMap[vId] = item.quantity;
          });
        }
        serverCartMap = newServerMap;

        Object.keys(cartItemsMap).forEach(vId => {
          if (!newMap[vId] && !variantDebounceTimers[vId]) {
            delete cartItemsMap[vId];
          }
        });

        Object.keys(newMap).forEach(vId => {
          if (!variantDebounceTimers[vId]) {
            cartItemsMap[vId] = newMap[vId];
          }
        });

        localStorage.setItem('theme_cart_products', JSON.stringify(Object.keys(cartItemsMap)));
        const uniqueVariantsCount = cart && cart.items ? cart.items.length : (Object.keys(cartItemsMap).length || 0);
        lastUniqueCartCount = uniqueVariantsCount;
        updateCartBubble(uniqueVariantsCount);
        
        document.querySelectorAll('.product-card__atc-container').forEach(container => {
          const vId = container.dataset.variantId ? container.dataset.variantId.toString() : '';
          if (variantDebounceTimers[vId]) return;
          const qty = cartItemsMap[vId] || 0;
          renderProductCardAtc(container, vId, qty);
        });

        // Sync and restore multi-variant cards
        document.querySelectorAll('.product-card[data-has-variants="true"]').forEach(card => {
          const variantsScript = card.querySelector('.product-card-variants-json');
          if (!variantsScript) return;
          let variants = [];
          try {
            variants = JSON.parse(variantsScript.textContent.trim());
          } catch (e) { return; }

          const inCartVariant = variants.find(v => (cartItemsMap[v.id.toString()] || 0) > 0);
          if (inCartVariant) {
            const qty = cartItemsMap[inCartVariant.id.toString()];
            applyVariantToCard(card, inCartVariant, qty);
          } else {
            resetCardToDefault(card);
          }
        });

        checkProductPageAtcButtonState();

        if (typeof window.updateFloatingCartBar === 'function') {
          window.updateFloatingCartBar(cart);
        }
        updateSearchCartPill(cart);

        return cart;
      })
      .catch(err => {
        console.error('Error syncing cart:', err);
      });
  };

  window.syncCartWithServer = syncCartWithServer;

  // BFCache (Back-Forward Cache) & Visibility sync handlers:
  window.addEventListener('pageshow', function() {
    syncCartWithServer();
  });
  window.addEventListener('focus', function() {
    syncCartWithServer();
  });
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      syncCartWithServer();
    }
  });

  const resetCardToDefault = (card) => {
    if (!card) return;
    const defaultVId = card.dataset.defaultVariantId;
    const defaultWeight = card.dataset.defaultWeight || '';
    const defaultPrice = card.dataset.defaultPrice || '';
    const defaultCompare = card.dataset.defaultComparePrice || '';

    const container = card.querySelector('.product-card__atc-container');
    if (container && defaultVId) {
      container.dataset.variantId = defaultVId;
      renderProductCardAtc(container, defaultVId, 0);
    }

    const weightEl = card.querySelector('[data-card-weight]');
    if (weightEl) {
      weightEl.textContent = defaultWeight;
      if (!defaultWeight && card.dataset.hasVariants !== 'true') {
        weightEl.style.display = 'none';
      } else {
        weightEl.style.display = '';
      }
    }

    const priceEl = card.querySelector('[data-card-price]');
    if (priceEl && defaultPrice) {
      priceEl.textContent = defaultPrice;
    }

    const compareEl = card.querySelector('[data-card-compare-price]');
    if (compareEl) {
      if (defaultCompare) {
        compareEl.textContent = defaultCompare;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    delete card.dataset.activeVariantId;
  };

  const applyVariantToCard = (card, variant, qty = 1, direction = 'inc') => {
    if (!card || !variant) return;
    const vId = variant.id.toString();
    card.dataset.activeVariantId = vId;

    const container = card.querySelector('.product-card__atc-container');
    if (container) {
      container.dataset.variantId = vId;
      renderProductCardAtc(container, vId, qty, direction);
    }

    const weightEl = card.querySelector('[data-card-weight]');
    if (weightEl) {
      weightEl.textContent = variant.title;
      weightEl.style.display = '';
    }

    const priceEl = card.querySelector('[data-card-price]');
    if (priceEl && variant.priceFormatted) {
      priceEl.textContent = variant.priceFormatted;
    }

    const compareEl = card.querySelector('[data-card-compare-price]');
    if (compareEl) {
      if (variant.compareAtPriceFormatted) {
        compareEl.textContent = variant.compareAtPriceFormatted;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
  };

  let activeVariantModalCard = null;
  let currentModalVariants = [];

  const updateVariantModalFooter = () => {
    const modal = document.getElementById('theme-variant-modal');
    if (!modal) return;
    let prodQty = 0;
    let prodTotal = 0;
    currentModalVariants.forEach(v => {
      const q = cartItemsMap[v.id.toString()] || 0;
      if (q > 0) {
        prodQty += q;
        const priceNum = typeof v.price === 'number' && v.price > 1000 ? v.price / 100 : Number(v.price) || 0;
        prodTotal += q * priceNum;
      }
    });

    const itemsEl = modal.querySelector('.theme-variant-modal__footer-items');
    const totalEl = modal.querySelector('.theme-variant-modal__footer-total');
    if (itemsEl) {
      itemsEl.textContent = prodQty > 0 ? `${prodQty} ${prodQty === 1 ? 'item' : 'items'} in Cart` : 'Select Pack Size';
    }
    if (totalEl) {
      totalEl.textContent = prodQty > 0 ? `₹${Math.round(prodTotal).toLocaleString('en-IN')}` : '₹0';
    }
  };

  const getOrCreateVariantModal = () => {
    let modal = document.getElementById('theme-variant-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'theme-variant-modal';
      modal.className = 'theme-variant-modal';
      modal.setAttribute('aria-hidden', 'true');
      modal.innerHTML = `
        <div class="theme-variant-modal__overlay"></div>
        <div class="theme-variant-modal__sheet">
          <div class="theme-variant-modal__drag-handle"></div>
          <div class="theme-variant-modal__header">
            <div class="theme-variant-modal__prod-info">
              <div class="theme-variant-modal__prod-img-wrap">
                <img class="theme-variant-modal__prod-img" src="" alt="" />
              </div>
              <div class="theme-variant-modal__prod-meta">
                <h4 class="theme-variant-modal__title"></h4>
                <span class="theme-variant-modal__subtitle">Select Pack Size</span>
              </div>
            </div>
            <button type="button" class="theme-variant-modal__close-btn" aria-label="Close modal">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>
          </div>
          <div class="theme-variant-modal__list"></div>
          <div class="theme-variant-modal__footer">
            <div class="theme-variant-modal__footer-info">
              <span class="theme-variant-modal__footer-items">0 items in Cart</span>
              <span class="theme-variant-modal__footer-total">₹0</span>
            </div>
            <button type="button" class="theme-variant-modal__checkout-btn" id="theme-variant-modal-checkout-btn">
              <span>Checkout Now</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
          </div>
        </div>
      `;
      (document.documentElement || document.body).appendChild(modal);

      const closeModal = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('variant-modal-open');
        document.documentElement.classList.remove('variant-modal-open');
        if (window.GNC_POPUP_MANAGER && typeof window.GNC_POPUP_MANAGER.notifyClosed === 'function') {
          window.GNC_POPUP_MANAGER.notifyClosed('theme-variant-modal');
        }
        checkProductPageAtcButtonState();
      };
      window.closeVariantModal = closeModal;

      modal.querySelector('.theme-variant-modal__overlay').addEventListener('click', closeModal);
      const closeBtn = modal.querySelector('.theme-variant-modal__close-btn');
      if (closeBtn) closeBtn.addEventListener('click', closeModal);

      const checkoutBtn = modal.querySelector('#theme-variant-modal-checkout-btn');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', () => {
          const targetCheckoutUrl = typeof window.getCheckoutUrlWithLocation === 'function'
            ? window.getCheckoutUrlWithLocation('/pages/checkout')
            : '/pages/checkout';
          const isLoggedIn = typeof window.isUserLoggedIn === 'function' ? window.isUserLoggedIn() : false;
          if (!isLoggedIn && typeof window.openLoginWelcomeModal === 'function') {
            closeModal();
            window.openLoginWelcomeModal({
              returnTo: targetCheckoutUrl,
              title: 'Sign In to Complete Purchase',
              subtitle: 'Please sign in or create an account to proceed with your order and enjoy express checkout.'
            });
            return;
          }
          window.location.href = targetCheckoutUrl;
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    }
    return modal;
  };

  const openVariantSelectorModal = (source) => {
    activeVariantModalCard = source || null;

    let variants = [];
    let prodTitle = '';
    let prodImg = '';

    if (source && source.classList && source.classList.contains('product-card')) {
      const variantsScript = source.querySelector('.product-card-variants-json');
      if (variantsScript) {
        try {
          variants = JSON.parse(variantsScript.textContent.trim());
        } catch (e) {}
      }
      prodTitle = source.dataset.productTitle || source.querySelector('.product-card__title a')?.textContent?.trim() || 'Product';
      prodImg = source.dataset.productImage || source.querySelector('.product-card__image')?.src || '';
    } else {
      const variantsScript = document.querySelector('.product-variants-data-json, [id^="product-variants-json-"]');
      if (variantsScript) {
        try {
          const parsed = JSON.parse(variantsScript.textContent.trim());
          if (Array.isArray(parsed)) {
            variants = parsed.map(v => ({
              id: v.id,
              title: v.title,
              price: v.price,
              priceFormatted: v.priceFormatted || (typeof v.price === 'number' ? `₹${Math.round(v.price / 100)}` : `₹${v.price}`),
              compareAtPrice: v.compareAtPrice || v.compare_at_price || 0,
              compareAtPriceFormatted: v.compareAtPriceFormatted || ((v.compare_at_price || v.compareAtPrice) > v.price ? `₹${Math.round((v.compare_at_price || v.compareAtPrice) / 100)}` : ''),
              available: v.available !== false
            }));
          }
        } catch (e) {}
      }
      prodTitle = document.querySelector('.custom-details__title')?.textContent?.trim() || 'Product';
      prodImg = document.getElementById('gallery-main-img')?.src || document.querySelector('.custom-details__main-image img')?.src || '';
    }

    if (!variants || variants.length === 0) return;

    // Sort variants from highest price/pack size to lowest (higher to lower)
    variants.sort((a, b) => (Number(b.price) || 0) - (Number(a.price) || 0));
    currentModalVariants = variants;

    const modal = getOrCreateVariantModal();
    const titleEl = modal.querySelector('.theme-variant-modal__title');
    const imgEl = modal.querySelector('.theme-variant-modal__prod-img');
    const listEl = modal.querySelector('.theme-variant-modal__list');

    titleEl.textContent = toTitleCase(prodTitle);
    if (prodImg) {
      imgEl.src = prodImg;
      imgEl.alt = toTitleCase(prodTitle);
      imgEl.parentElement.style.display = 'block';
    } else {
      imgEl.parentElement.style.display = 'none';
    }

    const renderModalList = () => {
      listEl.innerHTML = variants.map(v => {
        const vId = v.id.toString();
        const qty = cartItemsMap[vId] || 0;
        const isCurrent = (source && source.dataset && source.dataset.activeVariantId === vId) || (!source?.dataset?.activeVariantId && source?.dataset?.defaultVariantId === vId);
        
        let discountHtml = '';
        if (v.compareAtPrice > v.price) {
          const pct = Math.round(((v.compareAtPrice - v.price) / v.compareAtPrice) * 100);
          discountHtml = `<span class="theme-variant-modal__badge">${pct}% OFF</span>`;
        }

        let atcHtml = '';
        if (!v.available) {
          atcHtml = `<button type="button" class="theme-variant-modal__add-btn blinkit-add-btn" disabled style="opacity: 0.5;">Sold Out</button>`;
        } else if (qty > 0) {
          atcHtml = `
            <div class="product-card__qty-selector theme-variant-modal__qty-selector" data-variant-id="${vId}">
              <button type="button" class="qty-btn qty-btn--minus" data-action="minus" aria-label="Decrease quantity">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              </button>
              <span class="qty-count">
                <span class="qty-num">${qty}</span>
              </span>
              <button type="button" class="qty-btn qty-btn--plus" data-action="plus" aria-label="Increase quantity">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              </button>
            </div>
          `;
        } else {
          atcHtml = `
            <button type="button" class="theme-variant-modal__add-btn blinkit-add-btn" data-variant-id="${vId}">
              ADD
            </button>
          `;
        }

        return `
          <div class="theme-variant-modal__row ${isCurrent ? 'is-selected' : ''}" data-variant-id="${vId}">
            <div class="theme-variant-modal__row-left">
              <span class="theme-variant-modal__row-title">${v.title}</span>
              ${discountHtml}
            </div>
            <div class="theme-variant-modal__row-right">
              <div class="theme-variant-modal__row-price">
                <span class="theme-variant-modal__price-curr">${v.priceFormatted}</span>
                ${v.compareAtPriceFormatted ? `<s class="theme-variant-modal__price-was">${v.compareAtPriceFormatted}</s>` : ''}
              </div>
              <div class="theme-variant-modal__row-action" data-variant-id="${vId}">
                ${atcHtml}
              </div>
            </div>
          </div>
        `;
      }).join('');
    };

    renderModalList();
    updateVariantModalFooter();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('variant-modal-open');
    if (window.GNC_POPUP_MANAGER && typeof window.GNC_POPUP_MANAGER.notifyOpened === 'function') {
      window.GNC_POPUP_MANAGER.notifyOpened('theme-variant-modal');
    }
  };
  window.openVariantModal = openVariantSelectorModal;

  syncCartWithServer();

  document.addEventListener('click', function(e) {
    // Wishlist remove button click delegation
    const removeBtn = e.target.closest('.wishlist-remove-btn');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const handle = removeBtn.dataset.productHandle;
      if (!handle) return;

      wishlist = wishlist.filter(item => item !== handle);
      localStorage.setItem('theme_wishlist', JSON.stringify(wishlist));
      updateWishlistBubble();
      
      const card = removeBtn.closest('.product-card');
      if (card && document.body.contains(card)) {
        card.style.opacity = '0';
        card.style.transform = 'scale(0.9)';
        card.style.transition = 'all 0.3s ease';
        setTimeout(() => {
          card.remove();
          const grid = document.getElementById('wishlist-products-grid');
          if (grid && grid.children.length === 0) {
            grid.style.display = 'none';
            const emptyState = document.getElementById('wishlist-empty-state');
            if (emptyState) emptyState.style.display = 'block';
          }
        }, 300);
      }
      return;
    }

    // Wishlist toggle click delegation
    const wishlistBtn = e.target.closest('.wishlist-btn');
    if (wishlistBtn) {
      e.preventDefault();
      e.stopPropagation();
      const handle = wishlistBtn.dataset.productHandle;
      if (!handle) return;

      const isActive = wishlistBtn.classList.contains('active');
      const svg = wishlistBtn.querySelector('svg');

      if (isActive) {
        wishlistBtn.classList.remove('active');
        if (svg) {
          svg.style.fill = 'none';
          svg.style.stroke = 'currentColor';
        }
        wishlist = wishlist.filter(item => item !== handle);
      } else {
        wishlistBtn.classList.add('active');
        if (svg) {
          svg.style.fill = '#e22c2c';
          svg.style.stroke = '#e22c2c';
        }
        wishlist.push(handle);
      }
      localStorage.setItem('theme_wishlist', JSON.stringify(wishlist));
      updateWishlistBubble();
      return;
    }

    // Quantity Selector Buttons (+ / -) in Modal & Product Cards
    const qtyBtn = e.target.closest('.product-card__qty-selector .qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      const selector = qtyBtn.closest('.product-card__qty-selector');
      if (!selector) return;

      const variantId = selector.dataset.variantId;
      const action = qtyBtn.dataset.action;
      if (!variantId) return;

      const currentQty = cartItemsMap[variantId] || 1;
      const direction = action === 'plus' ? 'inc' : 'dec';
      const newQty = action === 'plus' ? currentQty + 1 : Math.max(0, currentQty - 1);

      // INSTANT OPTIMISTIC UI UPDATE (< 1ms)
      cartItemsMap[variantId] = newQty;
      updateCardContainersForVariant(variantId, newQty, direction);
      updateCartBubble();
      if (typeof window.updateFloatingCartBar === 'function') {
        window.updateFloatingCartBar(getOptimisticTotalCartItems(), true);
      }

      // Check if inside modal
      const modal = document.getElementById('theme-variant-modal');
      const insideModal = qtyBtn.closest('#theme-variant-modal');
      if (insideModal) {
        const rowAction = selector.closest('.theme-variant-modal__row-action');
        if (rowAction) {
          if (newQty > 0) {
            const numEl = rowAction.querySelector('.qty-num');
            if (numEl) {
              numEl.textContent = newQty;
              numEl.classList.remove('qty-inc', 'qty-dec');
              void numEl.offsetWidth;
              numEl.classList.add(direction === 'inc' ? 'qty-inc' : 'qty-dec');
            }
          } else {
            rowAction.innerHTML = `<button type="button" class="theme-variant-modal__add-btn blinkit-add-btn" data-variant-id="${variantId}">ADD</button>`;
          }
        }
        updateVariantModalFooter();
      }

      // If newQty === 0, reset any multi-variant cards displaying this variant back to default!
      if (newQty === 0) {
        document.querySelectorAll('.product-card[data-has-variants="true"]').forEach(c => {
          if (c.dataset.activeVariantId === variantId.toString()) {
            resetCardToDefault(c);
          }
        });
      }

      // Sync PDP Add More vs Add to Cart state
      checkProductPageAtcButtonState();

      // DEBOUNCED & SEQUENCED NETWORK SYNC
      syncVariantQuantityToServer(variantId, newQty);
      return;
    }

    // Add to Cart click delegation
    const atcBtn = e.target.closest('.ajax-add-to-cart, .blinkit-add-btn, .custom-details__add-btn, .pdp-open-variants-btn');
    if (atcBtn) {
      e.preventDefault();
      if (atcBtn.disabled) return;

      const insideModal = atcBtn.closest('#theme-variant-modal');
      const card = atcBtn.closest('.product-card');
      const isPdpBtn = atcBtn.classList.contains('pdp-open-variants-btn') || atcBtn.closest('.custom-details__actions, .custom-details-section') || atcBtn.id === 'gnc-sticky-atc-btn';
      const hasVariants = atcBtn.dataset.hasVariants === 'true' || card?.dataset.hasVariants === 'true' || !!document.querySelector('.product-variants-data-json');

      // 1. INSIDE VARIANT MODAL: Add variant without closing modal!
      if (insideModal) {
        const variantId = atcBtn.dataset.variantId;
        if (!variantId) return;

        const newQty = 1;
        cartItemsMap[variantId] = newQty;

        const rowAction = atcBtn.closest('.theme-variant-modal__row-action');
        if (rowAction) {
          rowAction.innerHTML = `
            <div class="product-card__qty-selector theme-variant-modal__qty-selector" data-variant-id="${variantId}">
              <button type="button" class="qty-btn qty-btn--minus" data-action="minus" aria-label="Decrease quantity">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              </button>
              <span class="qty-count">
                <span class="qty-num qty-inc">${newQty}</span>
              </span>
              <button type="button" class="qty-btn qty-btn--plus" data-action="plus" aria-label="Increase quantity">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
              </button>
            </div>
          `;
        }

        updateVariantModalFooter();

        if (activeVariantModalCard && activeVariantModalCard.classList && activeVariantModalCard.classList.contains('product-card')) {
          const variantsScript = activeVariantModalCard.querySelector('.product-card-variants-json');
          if (variantsScript) {
            try {
              const variants = JSON.parse(variantsScript.textContent.trim());
              const chosenVariant = variants.find(v => v.id.toString() === variantId.toString());
              if (chosenVariant) {
                applyVariantToCard(activeVariantModalCard, chosenVariant, newQty, 'inc');
              }
            } catch (e) {}
          }
        }

        updateCartBubble();
        if (typeof window.updateFloatingCartBar === 'function') {
          window.updateFloatingCartBar(getOptimisticTotalCartItems(), true);
        }
        updateSearchCartPill();
        checkProductPageAtcButtonState();

        syncVariantQuantityToServer(variantId, newQty);
        return;
      }

      // 2. OUTSIDE MODAL: If PDP or Card has multiple variants, open the modal!
      if (isPdpBtn) {
        if (hasVariants) {
          openVariantSelectorModal(document.querySelector('.custom-details__actions') || document.querySelector('.custom-details__container'));
          return;
        }
      } else if (card && hasVariants) {
        openVariantSelectorModal(card);
        return;
      }

      // 3. Single variant direct addition
      let variantId = atcBtn.dataset.variantId || document.getElementById('custom-details-selected-variant-id')?.value;
      const container = atcBtn.closest('.product-card__atc-container');
      const handle = (container && container.dataset.productHandle) || atcBtn.dataset.productHandle;

      const executeAddToCart = (targetVId) => {
        const currentQty = (window.getVariantQtyInCart && window.getVariantQtyInCart(targetVId)) || cartItemsMap[targetVId] || 0;
        const newQty = currentQty + 1;

        cartItemsMap[targetVId] = newQty;

        if (container) {
          container.dataset.variantId = targetVId;
          renderProductCardAtc(container, targetVId, newQty, 'inc');
          updateCardContainersForVariant(targetVId, newQty, 'inc');
        }

        updateCartBubble();
        if (typeof window.updateFloatingCartBar === 'function') {
          window.updateFloatingCartBar(getOptimisticTotalCartItems(), true);
        }
        updateSearchCartPill();
        checkProductPageAtcButtonState();

        syncVariantQuantityToServer(targetVId, newQty);
      };

      if ((!variantId || atcBtn.dataset.isProductId === 'true') && handle) {
        atcBtn.disabled = true;
        fetch(`/products/${handle}.js`)
          .then(res => res.json())
          .then(prodData => {
            atcBtn.disabled = false;
            if (prodData && prodData.variants && prodData.variants[0]) {
              const realVariantId = prodData.variants[0].id.toString();
              atcBtn.dataset.variantId = realVariantId;
              atcBtn.removeAttribute('data-is-product-id');
              if (container) container.dataset.variantId = realVariantId;
              executeAddToCart(realVariantId);
            }
          })
          .catch(err => {
            atcBtn.disabled = false;
            console.error('Error resolving variant ID:', err);
          });
      } else if (variantId) {
        executeAddToCart(variantId);
      }
      return;
    }

    // Shop Now Click Delegation
    const buyNowBtn = e.target.closest('#custom-details-buy-now, .custom-details__buy-btn');
    if (buyNowBtn) {
      e.preventDefault();
      const hasVariants = buyNowBtn.dataset.hasVariants === 'true' || !!document.querySelector('.product-variants-data-json');
      if (hasVariants) {
        openVariantSelectorModal(document.querySelector('.custom-details__actions') || document.querySelector('.custom-details__container'));
        return;
      }

      const variantInput = document.getElementById('custom-details-selected-variant-id');
      const variantId = variantInput ? variantInput.value : buyNowBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      const targetCheckoutUrl = typeof window.getCheckoutUrlWithLocation === 'function'
        ? window.getCheckoutUrlWithLocation('/pages/checkout')
        : '/pages/checkout';

      buyNowBtn.innerText = 'Processing...';
      buyNowBtn.disabled = true;

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(() => {
          return fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
        })
        .then(() => {
          buyNowBtn.innerText = 'Shop Now';
          buyNowBtn.disabled = false;
          window.location.href = targetCheckoutUrl;
        })
        .catch(() => {
          buyNowBtn.innerText = 'Shop Now';
          buyNowBtn.disabled = false;
        });
      return;
    }
  });

  // PDP Quantity Direct Numeric Input Change Listener
  document.addEventListener('change', function(e) {
    const qtyInput = e.target.closest('.custom-details__quantity .qty-input');
    if (qtyInput) {
      const form = qtyInput.closest('form') || document.querySelector('.custom-details__form');
      const addBtn = form ? form.querySelector('.custom-details__add-btn') : document.querySelector('.custom-details__add-btn');
      const variantInput = form ? form.querySelector('input[name="id"]') : document.getElementById('custom-details-selected-variant-id');
      const stickyAtcBtn = document.getElementById('gnc-sticky-atc-btn');
      const variantId = (addBtn && addBtn.getAttribute('data-variant-id')) || (variantInput && variantInput.value) || (stickyAtcBtn && stickyAtcBtn.getAttribute('data-variant-id'));
      const strId = variantId ? variantId.toString() : '';
      const isInCart = addBtn && addBtn.classList.contains('is-view-cart');

      let val = parseInt(qtyInput.value);
      if (isNaN(val) || val < 0) val = 1;

      if (isInCart && strId) {
        if (val === 0) {
          cartItemsMap[strId] = 0;
          qtyInput.value = 1;
          if (addBtn) {
            addBtn.classList.remove('added', 'is-view-cart');
            addBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg><span class="btn-text">Add to Cart</span>';
          }
          if (stickyAtcBtn) {
            stickyAtcBtn.classList.remove('is-view-cart');
            stickyAtcBtn.textContent = 'Add to Cart';
          }
        } else {
          cartItemsMap[strId] = val;
          qtyInput.value = val;
        }
        updateCardContainersForVariant(strId, val);
        updateCartBubble();
        if (typeof window.updateFloatingCartBar === 'function') {
          window.updateFloatingCartBar(getOptimisticTotalCartItems(), true);
        }
        updateSearchCartPill();
        syncVariantQuantityToServer(strId, val);
      } else {
        qtyInput.value = Math.max(1, val);
      }
    }
  });

  // Global Title Case Formatter for Product Titles (Abc format)
  function toTitleCase(str) {
    if (!str || typeof str !== 'string') return str || '';
    return str.toLowerCase().replace(/(?:^|\s|\/|-|\(|\.|,)\w/g, function(match) {
      return match.toUpperCase();
    });
  }
  window.toTitleCase = toTitleCase;

  function formatAllProductTitles() {
    const titleSelectors = [
      '.product-card__title a',
      '.product-card__title',
      '.custom-details__title',
      '.custom-product__title',
      '.product-details__title',
      '.product-details__heading',
      '.mega-menu__product-title',
      '.blinkit-card-title',
      '.search-dropdown__item-title',
      '.theme-variant-modal__title',
      '.order-item__title',
      '.cart-item__title',
      '.cart-drawer__item-title',
      '.product-extraction__title',
      'h1.product-title'
    ];
    document.querySelectorAll(titleSelectors.join(',')).forEach(el => {
      if (el && el.children.length === 0 && el.textContent) {
        const text = el.textContent.trim();
        if (text && el.dataset.titleFormatted !== text) {
          el.textContent = toTitleCase(text);
          el.dataset.titleFormatted = el.textContent;
        }
      }
    });
  }

  formatAllProductTitles();
  // Format on DOM mutations / dynamic contents
  try {
    const titleObserver = new MutationObserver(() => {
      formatAllProductTitles();
    });
    titleObserver.observe(document.body, { childList: true, subtree: true });
  } catch(e) {}
});

